import React, {createContext} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import main from "./store/mainStore";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
export const Context = createContext(null);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const stores = {
  main,
  user: main.user,
  settings: main.settings,
  basket: main.basket,
  delivery: main.delivery,
  lastViewedStore: main.lastviewed,
};

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Context.Provider value={{ ...stores }}>
      <App />
    </Context.Provider>
  </QueryClientProvider>,

  document.getElementById("root")
);


